import React from 'react'
import { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faFloppyDisk} from '@fortawesome/free-solid-svg-icons'
import getCookie from '../../../partials/cookie';
import {datePhrase, convertDate} from '../../../functions/Functions';
import {Errors} from '../../../partials/Partials';
import { LoadingContext } from '../../../partials/Context';

function Data(props) {
  const {lawyer_data, lawyer, setPaymentData, payment_data} = props
  const {premium, is_premium, id} = lawyer || '';

  const [edited_item, setEditedItem] = useState(false);
  const [errors, setErrors] = useState([]);
  const {setLoading} = useContext(LoadingContext)

  const {address_city, address_post_code, address_street,name,nip} = payment_data || '';
  const keys = ['Nazwa odbiorcy', 'Adres', 'Miasto', 'Kod pocztowy', 'NIP'];
  const values = [name, address_street, address_city, address_post_code, nip];
  const variables_names = ['name', 'address_street', 'address_city', 'address_post_code', 'nip'];
  let list = [];

  const {invoice_data_id} = lawyer_data || '';
  let premium_date = ''
  
  premium ? 
    premium_date = datePhrase(convertDate(new Date(premium)))
    :
    premium_date = ''

  useEffect(() => {
    if (invoice_data_id && edited_item === false) {
    setLoading(true)
    fetch(`/api/lawyer_invoice_data/${invoice_data_id}`).then(res => {
      if (res.ok) {
        res.json().then(
          data => {
            setPaymentData(data)
            setLoading(false)
          }
        )
      } else {
        res.json().then(
          data => {
            console.log(data)
            setErrors(['Nie udało się pobrać danych do faktury'])
            setLoading(false)
          }
        )
      }
    })
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice_data_id, edited_item])

  
  const sendData = (e, index) => {
      e.preventDefault()
      let value = e.target.querySelector('#data-input').value
      let value_name = variables_names[index];
      setEditedItem(false)
      if (value || index === 3) {
        var csrftoken = getCookie('csrftoken');
        fetch(`/api/lawyer_invoice_data/${invoice_data_id}/`, {
          method: 'PUT',
          headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                  ...payment_data,
                  [value_name]: value,
                  lawyerprofile: id,
            })
        }).then(res => {
          if (res.ok) {
              setErrors([])
          } else {
            res.json().then(data => {
              const {nip} = data || ''
              if (nip) {
                setErrors(nip)
              }
            })
          }
        })
      }
  }

  keys.forEach((name, index) => {
    let star = index !== 3 ? <sup>*</sup> : '';

    list.push(
      <div className="data-item" key={index}>
        <span className="data-title">{name}{star}: </span>
        {edited_item === index ? 
          <>
            <form onSubmit={(e) => sendData(e, index)} style={{display: 'flex'}}>
              <input id="data-input" type="text" placeholder={values[index]}/>
              <button type="submit" className="btn btn-edit">
                <FontAwesomeIcon icon={faFloppyDisk} />
                <span>Zapisz</span>
              </button>
            </form>
          </>
        :
          <>
            <span className="data-value">{values[index] ? values[index] : '-'}</span>
            <button onClick={() => setEditedItem(index)} className="btn btn-edit">
              <FontAwesomeIcon icon={faPencil} />
              <span>Zmień</span>
            </button>
          </>
        }
      </div>
    )
  })
  return (
    <div className="payment-data">
      <h3 className="title title-thin">Dane do faktury</h3>
      <div className="data-content">
          {list}
      </div>
      <Errors errors={errors} />
      <div className="premium-date">
        { is_premium ?
          <span>
            Obecnie posiadasz konto Premium do <strong>{premium_date}</strong>.
          </span>
          :
          <span>
            Obecnie <strong>nie posiadasz konta Premium.</strong>
          </span>
          
        }
      </div>
    </div>
  )
}

export default Data